import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import MainFeed from "./MainFeed";

const Feed2 = () => {
  return (
    <Container className="bg-light" style={{ marginTop: "90px", marginBottom: "40px" }}>
      <Row className="justify-content-center">
        <Col xs={12} md={10} lg={8}>
          <MainFeed />
        </Col>
      </Row>
    </Container>
  );
};

export default Feed2;


// import React from "react";
// import { Container, Row, Col } from "react-bootstrap";
// import MainFeed from "./MainFeed";
// import RightSidebar from "./RightSidebar";

// const Feed2 = () => {
//   return (
//     <Container className="bg-light" style={{ marginTop: "90px", marginBottom: "40px" }}>
//       <Row>
//         {/* MainFeed takes full width below lg (992px), 8 cols at ≥992px */}
//         <Col xs={12} lg={8}>
//           <MainFeed />
//         </Col>

//         {/* Sidebar only visible at ≥992px */}
//         <Col lg={4} className="d-none d-lg-block">
//           <RightSidebar />
//         </Col>
//       </Row>
//     </Container>
//   );
// };

// export default Feed2;
